var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#EAF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 33H16.6C16.0399 33 15.7599 33 15.546 32.891C15.3578 32.7951 15.2049 32.6422 15.109 32.454C15 32.2401 15 31.9601 15 31.4V15M32 20L28.0811 24.1827C27.9326 24.3412 27.8584 24.4204 27.7688 24.4614C27.6897 24.4976 27.6026 24.5125 27.516 24.5047C27.4179 24.4958 27.3215 24.4458 27.1287 24.3457L23.8713 22.6543C23.6785 22.5542 23.5821 22.5042 23.484 22.4953C23.3974 22.4875 23.3103 22.5024 23.2312 22.5386C23.1416 22.5796 23.0674 22.6588 22.9189 22.8173L19 27",
    stroke: "#0F62FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYield);
export default __webpack_public_path__ + "static/media/yield.bb4f4a00b889022f127909ce423d3647.svg";
export { ForwardRef as ReactComponent };